var map = {
	"./brand01.png": "iEn4",
	"./brand02.png": "h1n6",
	"./brand03.png": "qACt",
	"./brand04.png": "ZcMG",
	"./brand05.png": "Em3K",
	"./brand06.png": "y1sp",
	"./brand07.png": "R4p2",
	"./brand08.png": "ZHvK",
	"./brand09.png": "RJg+",
	"./brand10.png": "BtJD"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2gSO";